(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var elms = document.querySelectorAll('.splide-product-card');
    for (var i = 0; i < elms.length; i++) {
      const splide = new Splide(elms[i], {
        trimSpace: false,
        pauseOnHover: false,
        pagination: false,
        start: window.matchMedia('(min-width: 768px)').matches ? 1 : 0,
        flickMaxPages: 1,
        flickPower: 30,
        type: 'loop',
        speed: 0,
        rewindSpeed: 0,
        perPage: 1,
        drag: false,
      }).mount();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gift-card-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('product-gift-card-panel');
    if (!form) return;
    const optionInputs = form.querySelectorAll('input[type="radio"]');

    let variants = form.getAttribute('data-variant') ? JSON.parse(form.getAttribute('data-variant')) : [];
    let currentVariant = null;

    // Function to find the matching variant based on selected options
    function findVariant(selectedOptions) {
      return variants.find((variant) => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
    }

    // Get the initial selected options and update price
    function getSelectedOptions() {
      const selectedOptions = [];

      // Group inputs by option position
      const optionsByPosition = {};
      optionInputs.forEach((input) => {
        if (input.checked) {
          const position = parseInt(input.dataset.optionPosition);
          optionsByPosition[position] = input.value;
        }
      });

      // Sort by position and collect values
      Object.keys(optionsByPosition)
        .sort((a, b) => a - b)
        .forEach((position) => {
          selectedOptions.push(optionsByPosition[position]);
        });

      return selectedOptions;
    }

    // Initialize and set up event listeners
    function init() {
      const selectedOptions = getSelectedOptions();
      currentVariant = findVariant(selectedOptions);
      updateId(currentVariant);

      optionInputs.forEach((input) => {
        input.addEventListener('change', () => {
          const selectedOptions = getSelectedOptions();
          currentVariant = findVariant(selectedOptions);
          updateId(currentVariant);
        });
      });
    }

    function updateId(currentVariant) {
      const variantId = currentVariant ? currentVariant.id : null;
      const idInput = form.querySelector('input[name="id"]');
      idInput.value = variantId || '';
    }

    init();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-rte-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var elms = document.querySelectorAll('section.snippets-product-rte-carousel.splide');
    for (var i = 0; i < elms.length; i++) {
      new Splide(elms[i], {
        type: 'loop',
        trimSpace: false,
        autoWidth: true,
        perMove: 1,
        flickMaxPages: 1,
        flickPower: 30,
        gap: 20,
        mediaQuery: 'min',
      }).mount();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-rte-media"] && !Shopify.designMode) return;
  try {
    const sections_product_rte_media = document.querySelectorAll('.snippets-product-rte-media');
  sections_product_rte_media.forEach((section) => {
    if (!section.querySelector('video')) {
      return; // Skip if the section does not contain the product media
    }
    let productVideoManuallyTriggered = false;
    const video = section.querySelector('video');
    const videoPlayButton = section.querySelector('.product-video-play');
    // Create intersection observer to detect when video is out of viewport
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && video.paused === false && productVideoManuallyTriggered) {
            pauseVideo();
            video.pause();
            console.log('Video is out of viewport, pausing video');
          }
        });
      },
      { threshold: 0.2 }
    ); // Trigger when at least 20% is visible

    // Start observing the video element if it exists
    if (video) {
      observer.observe(video);
      console.log('Observing video element');
    }
    if (videoPlayButton) {
      videoPlayButton.addEventListener('click', playVideo);
      console.log('Video play button added');
    }
    function pauseVideo() {
      productVideoManuallyTriggered = false;
      video.removeAttribute('controls');
      videoPlayButton.style.display = 'block';
    }
    function playVideo() {
      productVideoManuallyTriggered = true;
      video.play();
      video.setAttribute('controls', 'true');
      section.querySelector('.product-video-play').style.display = 'none';
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-rte-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var elms = document.querySelectorAll('section.snippets-product-rte-upsell .splide.product-related');
    for (var i = 0; i < elms.length; i++) {
      const splide = new Splide(elms[i], {
        trimSpace: false,
        pauseOnHover: false,
        pagination: false,
        type: 'loop',
        perPage: 2,
        flickMaxPages: 1,
        flickPower: 30,
        perMove: 1,
        mediaQuery: 'min',
        breakpoints: {
          1024: {
            perPage: 3,
          },
        },
      }).mount();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
